// extracted by mini-css-extract-plugin
export default {"toolboxContainer":"ToolboxTable_toolboxContainer__V4g61"};